import { Button, Spacer, SvgChrome, Text } from '@loomhq/lens';
import React from 'react';

import { DOWNLOAD_RECORDER } from 'constants/checklist';
import {
  GET_STARTED_CHECKLIST_DESKTOP_APP_INSTALL_CLICKED,
  GET_STARTED_CHECKLIST_EXTENSION_INSTALL_CLICKED,
} from 'constants/events';
import { CHROME_EXT_WEBSTORE_URL } from 'constants/routes';
import * as analytics from 'utilities/analytics';
import {
  getSupportedPlatformType,
  isSupportedDesktopPlatform,
} from 'utilities/download-desktop';

import { useCompleteChecklistItem } from 'hooks/checklist';

import DownloadDesktopButton from '../../../../download-desktop-button';

const DownloadCTA = () => {
  const { completeChecklistItem } = useCompleteChecklistItem(DOWNLOAD_RECORDER);

  const platform = getSupportedPlatformType();

  return (
    <div>
      <Text>
        Download the desktop app to record from anywhere. Install the Chrome
        extension to record from your browser and to unlock integrations like
        Gmail and Jira.
      </Text>
      <Spacer top="large" bottom="small">
        <Button
          variant="primary"
          icon={<SvgChrome />}
          onClick={() => {
            analytics.track(GET_STARTED_CHECKLIST_EXTENSION_INSTALL_CLICKED);
            completeChecklistItem();
            window.open(CHROME_EXT_WEBSTORE_URL, '_blank');
          }}
          hasFullWidth
        >
          Install Chrome Extension
        </Button>
      </Spacer>

      {isSupportedDesktopPlatform && (
        <DownloadDesktopButton
          hasFullWidth
          afterOnClick={() => {
            analytics.track(GET_STARTED_CHECKLIST_DESKTOP_APP_INSTALL_CLICKED, {
              platform,
            });

            completeChecklistItem();
          }}
        />
      )}
    </div>
  );
};

export default DownloadCTA;
